import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";

import { ShoppingItemModel } from "src/app/core/models/shopping-item.model";
import * as _ from "lodash";
import { Product } from "src/app/shared/models/product";
@Component({
  selector: "app-shopping-item",
  templateUrl: "./shopping-item.component.html",
  styleUrls: ["./shopping-item.component.scss"],
})
export class ShoppingItemComponent implements OnInit {
  @Input() shoppingItem: Product;
  @Output() sendDataToCart = new EventEmitter<string>();
  itemDescription: string = "";
  constructor() { }

  ngOnInit() {
    this.itemDescription = this.shoppingItem.productName;
    _.each(this.shoppingItem.toppings, (topping) => {
      this.itemDescription += " + " + topping.productName;
    });
  }

  minus() {
    this.sendDataToCart.emit("minus");
  }
  plus() {
    this.sendDataToCart.emit("plus");
  }
  edit() {
    this.sendDataToCart.emit("edit");
  }
  delete() {
    this.sendDataToCart.emit("delete");
  }
}
